import $ from 'jquery'
import ManageFields from '@/views/parametres/champs/manage-fields'

export default {
    name: 'champs',
    components: {
        ManageFields
    },
    props: [],
    data() {
        return {
            is_empty: false,
            is_loading: true,
            is_error: false,
            empty_msg_error: "",

            fields: [
                'champ', { key: 'type', label: 'Type de champ' },
                { key: 'occurence', label: 'Occurence.s' }, 'statut', { key: 'etat', label: 'État'},
                { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: 25,
            currentPage: 1,

            detail_champ: {
                champ_id: 0,
                champ: '',
                type: '',
                occurences: [],
                is_required: 0
            },

            selected_type_champ: '',
            c_occurence: '',
            filtered_occurence: [],
            selected_champ_occurences: [],

            can_show_occurence: false,

            save_loading: false,
            btn_disable: false,

            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: [],
            liste_type_champs: [],
            selected_field: {},
            toggler: 0
        }
    },

    computed: {
        type_champs() {
            return this.$store.getters["type_champs"];
        },

        liste_occurences() {
            return this.$store.getters["liste_occurences"];
        },

        liste_champs() {
            return this.$store.getters["liste_champs"];
        },

        list_consultations() {
            return this.$store.getters["list_consultations"];
        },
    },
    mounted() {
        // Liste des types de consultation
        this.$store.dispatch("getTousTypeConsultations")

        // Liste type de champs
        this.$store.dispatch("getTypeChamps").then(() => {
            // set type champs to liste_type_champs only if champ != 'Date' && champ != 'Heure'
            this.liste_type_champs = this.type_champs.filter((el) => {
                return el.champ != 'Date' && el.champ != 'Heure' && el.champ != 'Fichier'
            })
        })

        // Liste occurences
        this.$store.dispatch("getListeOccurences")

        // Liste des champs
        this.refreshListeChamp()
    },
    methods: {
        async refreshListeChamp() {
            this.is_loading = true

            this.$store.dispatch("getListeChamps", 'examen_clinique').then(() => {
                if (this.liste_champs.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        onTypeChange() {
            let split_type_champ = this.selected_type_champ.split('.')
            this.detail_champ.type = split_type_champ[0]

            console.log(split_type_champ[1]);

            if (
                split_type_champ[1] == 'Choix déroulant' || split_type_champ[1] == 'Case à cocher' || 
                split_type_champ[1] == 'Choix unique' || split_type_champ[1] == 'Choix multiple'
            ) {
                this.can_show_occurence = true
            } else {
                this.can_show_occurence = false
                this.selected_champ_occurences = []
            }
        },

        addChamp() {
            this.one_is_checked = []
            this.text_grey = []
            this.detail_champ = {
                champ_id: 0,
                champ: '',
                type: '',
                occurences: [],
                is_required: 0
            }

            this.selected_champ_occurences = []
            this.selected_type_champ = ''
        },

        addToOccurence() {
            this.filtered_occurence = [];
            if (this.c_occurence.length > 2) {
                this.liste_occurences.forEach(
                    el => {
                        if (el.occurence.toLowerCase().includes(this.c_occurence.toLowerCase())) {
                            this.filtered_occurence.push(el)
                        }
                    }
                )
            }
        },

        /**
         * Ajouter une nouvelle occurence
         */
        addNewOccurence() {
            let j = 0
            let len = this.selected_champ_occurences.length

            let tmp_occurence = {
                id: 0,
                occurence: this.c_occurence
            }

            // Verifier si occurence déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.selected_champ_occurences.length; i++) {
                    if (this.c_occurence == this.selected_champ_occurences[i].occurence) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.selected_champ_occurences.push(tmp_occurence);

                this.c_occurence = ''
                this.filtered_motif = []
            }
        },

        addExistingOccurence(data) {
            let j = 0
            let len = this.selected_champ_occurences.length

            let tmp_occurence = {}
            this.liste_occurences.forEach(function (el) {
                if (data.occurence == el.occurence) {
                    tmp_occurence = {
                        id: el.id,
                        occurence: el.occurence
                    }
                }
            });

            // Verifier si occurence déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.selected_champ_occurences.length; i++) {
                    if (data.libelle == this.selected_champ_occurences[i].occurence) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.selected_champ_occurences.push(tmp_occurence);

                this.c_occurence = ''

            }
            this.filtered_occurence = []
        },

        removeOccurence(index) {
            this.selected_champ_occurences.splice(index, 1)
        },

        async submit() {
            const isValid = await this.$refs.champ_form.validate();
            if (!isValid) {
                this.save_loading = false
                this.btn_disable = false
                return;
            }

            if (this.one_is_checked.length == 0) {
                this.empty_msg_error = "Merci de choisir au moins un type de consultation !"
                return;
            }

            /**
             * Si Options Choix déroulant, Case à cocher ou Vrai/Faux choisies
             *      rendre le champ occurence obligatoire
             */
            let split_type_champ = this.selected_type_champ.split('.')
            let len = this.selected_champ_occurences.length
            if (
                split_type_champ[1] == 'Choix déroulant' || split_type_champ[1] == 'Case à cocher' || 
                split_type_champ[1] == 'Choix unique' || split_type_champ[1] == 'Choix multiple'
            ) {
                if (len == 0) {
                    this.errorMsg("Merci de définir les occurences pour ce champ !")

                    this.save_loading = false
                    this.btn_disable = false
                    return ;
                }
            } 

            let champ_data = {
                data_type: 'examen_clinique',
                champ_id: this.detail_champ.champ_id,
                champ: this.detail_champ.champ,
                type_champ_id: this.detail_champ.type,
                is_required: this.detail_champ.is_required,
                occurences: this.selected_champ_occurences,
                specialites: this.one_is_checked
            }
            console.log(champ_data)

            this.save_loading = true;
            this.btn_disable = true
            this.$store.dispatch('saveChamp', champ_data).then((response) => {
                if (response > 0) {
                    this.successMsg("Champ ajouté avec succès")

                    this.detail_champ = {
                        champ_id: 0,
                        champ: '',
                        type: '',
                        occurences: [],
                        is_required: 0
                    },
                    this.$refs.champ_form.reset()
                    this.refreshListeChamp()
                    this.$refs.modal_champ.click()
                    
                } else if (response == -1) {
                    this.is_error = true
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        editChamp(data) {
            this.one_is_checked = []
            this.text_grey = []
            this.detail_champ = {
                champ_id: data.champ_id,
                champ: data.champ,
                type: data.type_champ_id,
                is_required: data.est_requis,
            }

            this.selected_champ_occurences = data.occurences
            this.selected_type_champ = data.type_champ_id+'.'+data.type_champ

            data.accessibilites.forEach((acess_el) => {
                this.list_consultations.forEach((el) => {

                    if (acess_el.type_consultation_id == el.id) {
                        this.text_grey[el.id] = 'text-grey'
    
                        this.one_is_checked[el.id] = el.id
                    }
                    
                });
            })

            $('.add-champ').modal('show')
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        errorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-danger',
                type: 'danger',
                position: 'top-center'

            })
        },

        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.list_consultations.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.list_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            this.empty_msg_error = ""
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("consult-tous").checked = false;
        },

        deactivateField(field) {
            this.toggler = (this.toggler == 0)?1:0
            this.selected_field = field

            $('.deactivate-field').modal('show')
        }
    }
}